import { render, staticRenderFns } from "./PaperclipAscensionRow.vue?vue&type=template&id=56d21b64"
import script from "./PaperclipAscensionRow.vue?vue&type=script&lang=js"
export * from "./PaperclipAscensionRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports